import {List} from '@common/typescript/objects/List';
import {BaseUserWithAvatar} from '@common/react/objects/BaseUser';
import {Nullable} from '@common/typescript/objects/Nullable';
import { File } from '@common/typescript/objects/FileInterface';

export enum ChatMessageType {
	Regular = 0,
	VoiceMessage = 1,
	Email = 2,
	PhoneCall = 3,
	VideoChat = 4,
	VideoMessage = 5
}

export enum ChatKind
{
	Personal,
	Conference,
	Group,
	Help,
	Sos
}

export interface Chat {
	id: number;
	kind: ChatKind;
	time: number;
	name: string;
	contacts: BaseUserWithAvatar[];
	contactsIds: number[];
	messages: List<ChatMessage>;
	lastMessage: Nullable<ChatMessage>;
	unviewedMessagesCount: number;
	userId: number;
	archive?: boolean;
}

export interface ChatMessage {
	id: number;
	text: string;
	chatId: number;
	chat?: Chat;
	userId: number;
	user?: BaseUserWithAvatar;
	time: number;
	viewed: boolean;
	files: File[];
	chatMessageType: ChatMessageType;
}

export interface ChatMessageAccess {
	chatMessageObject?: ChatMessage;
	id: number;
	message: number;
	time: number;
	user?: BaseUserWithAvatar;
	userId: number;
	viewed: boolean;
}

export interface ChatUser {
	id: number;
	chatId: number;
	userId: number;
	user?: BaseUserWithAvatar;
	chat?: Chat;
}
